import { clsx } from 'clsx'
import { Vertical } from 'component/Vertical'
import { MeasurementsButton } from 'feature/measurements/MeasurementsButton'
import { observer } from 'mobx-react-lite'
import { SaveButton } from 'page/ProfileScreen/SaveButton/SaveButton'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './SaveButton.module.scss'

export const SaveButtonPane = observer(() => {
  const sticky = !opt.stand
  const full = store.profile?.type === 'full'
  const className = clsx(css.pane, sticky && css.sticky, opt.stand2 && css.stand)

  return <Vertical className={className} gap={12}>
    {full && opt.sizes && <MeasurementsButton profile={store.profile} />}
    <SaveButton />
  </Vertical>
})
